import React from 'react'
import PropTypes from "prop-types"
import { SVG_NAME_SPACE } from '../../constants/label.constants'

export default function ProfileSvg(props) {
  return (
  
     <svg xmlns={SVG_NAME_SPACE} className={props?.color} viewBox="0 0 261.5 252.4">
     <path className="st0" d="M0.4,0.4V252h260.8V0.4H0.4z M232.4,200c-41,57.7-132,67.7-186,24.7c-51.5-41-57.4-113-25.9-167.9
       c52-90.9,167.4-50.3,193.6-25.9C288.4,100.2,258.9,162.7,232.4,200z"></path>
     <path className="st1" d="M232,200.4c26.5-37.3,55.9-99.8-18.3-169.1C187.5,6.8,72.1-33.8,20.1,57.1
       c-31.5,55-25.6,127,25.9,167.9C100.1,268.1,191.1,258,232,200.4"></path>
 </svg>
    
  )
}

ProfileSvg.propTypes = {
  color:PropTypes.string,

}